import { render, staticRenderFns } from "./addMenu.vue?vue&type=template&id=c43e1142&scoped=true"
import script from "./addMenu.vue?vue&type=script&lang=js"
export * from "./addMenu.vue?vue&type=script&lang=js"
import style0 from "./addMenu.vue?vue&type=style&index=0&id=c43e1142&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c43e1142",
  null
  
)

export default component.exports